import request from '@/utils/request'

export function pageSim263Statistics(params) {
  return request({
    url: '/v3/manager/iot263/pageSim263Statistics',
    method: 'post',
    data: params
  })
}
export function pageSim263Table(params) {
  return request({
    url: '/v3/manager/iot263/pageSim263Table',
    method: 'post',
    data: params
  })
}
export function pageSimAllTable(params) {
  return request({
    url: '/v3/manager/iot263/pageSimAllTable',
    method: 'post',
    data: params
  })
}
// 编辑弹窗--提交
export function updateSim263Table(params) {
  return request({
    url: '/v3/manager/iot263/updateSim263Table',
    method: 'post',
    data: params
  })
}
// 编辑弹窗--重置
export function resetSim263Table(params) {
  return request({
    url: '/v3/manager/iot263/resetSim263Table',
    method: 'post',
    data: params
  })
}
// 上传excel
export function importUpdate(params, zoon) {
  var formData = new FormData()
  formData.append('file', params.raw)
  formData.append('zone', zoon)
  return request({
    url: '/v3/manager/iot263/importUpdate',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 下载
export function downLoadExcel(param) {
  // var url = process.env.VUE_APP_BASE_API  + '/v3/manager/chargerMsg/downLoad?token=' + getToken() + '&d1=' + d1 + '&d2=' + d2 + '&search=' + search + '&sn=' + sn
  var url = process.env.VUE_APP_BASE_API + '/v3/manager/iot263/exportSim263Table?companyIdList=' + param.companyIdList + '&exceed=' + param.exceed + '&status=' + param.status + '&iccId=' + param.iccId + '&yhubSn=' + param.yhubSn + '&pageNum=' + param.pageNum + '&pageSize=' + param.pageSize + '&status263=' + param.status263
  window.open(url, '_bank')
}
// 详情--历史记录
export function listSim263TableLog(params) {
  return request({
    url: '/v3/manager/iot263/listSim263TableLog?sn=' + params.sn,
    method: 'get'
  })
}

// 流量套餐列表页
export function pageSimDataPlan(params) {
  return request({
    url: '/v3/manager/dataService/pageSimDataPlan',
    method: 'post',
    data: params
  })
}
// 获取区域/洲和国家/地区级联列表
export function getRegionCountryList(params) {
  return request({
    url: '/v3/manager/dataService/getRegionCountryList',
    method: 'post',
    data: params
  })
}
// 流量套餐--新增
export function addSimDataPlan(params) {
  return request({
    url: '/v3/manager/dataService/addSimDataPlan',
    method: 'post',
    data: params
  })
}
// 流量套餐--编辑
export function editSimDataPlan(params) {
  return request({
    url: '/v3/manager/dataService/editSimDataPlan',
    method: 'post',
    data: params
  })
}
// 设备列表页
export function pageDeviceInfo(params) {
  return request({
    url: '/v3/manager/dataService/pageDeviceInfo',
    method: 'post',
    data: params
  })
}
// 续费详情
export function getDeviceRenewalLog(params) {
  return request({
    url: '/v3/manager/dataService/getDeviceRenewalLog?mcuId=' + params.mcuId,
    method: 'post',
    data: params
  })
}
// 订单列表页
export function pageDataServiceOrder(params) {
  return request({
    url: '/v3/manager/dataService/pageDataServiceOrder',
    method: 'post',
    data: params
  })
}
// 订单状态改变
export function updateDataServiceOrderStatus(params) {
  return request({
    url: '/v3/manager/dataService/updateDataServiceOrderStatus',
    method: 'post',
    data: params
  })
}
// 折扣列表页
export function pageSimDataPlanDiscount(params) {
  return request({
    url: '/v3/manager/dataService/pageSimDataPlanDiscount',
    method: 'post',
    data: params
  })
}
// 新增折扣
export function addSimDataPlanDiscount(params) {
  return request({
    url: '/v3/manager/dataService/addSimDataPlanDiscount',
    method: 'post',
    data: params
  })
}
// 编辑折扣
export function editSimDataPlanDiscount(params) {
  return request({
    url: '/v3/manager/dataService/editSimDataPlanDiscount',
    method: 'post',
    data: params
  })
}
// 公司--树状结构
export function listByCompanyParentId2(params) {
  return request({
    url: '/v3/user/company/listByCompanyParentId2',
    method: 'post',
    data: params
  })
}
// 公司服务费--树状结构
export function listCompanyServiceFee(params) {
  return request({
    url: '/v3/manager/dataService/listCompanyServiceFee',
    method: 'get',
    data: params
  })
}
// 批量更新服务费
export function batchUpdateCompanyServiceFee(params) {
  return request({
    url: '/v3/manager/dataService/batchUpdateCompanyServiceFee',
    method: 'post',
    data: params
  })
}

//根据iccId获取历史月份统计数据
export function listSimStatistics(params) {
  return request({
    url: '/v3/manager/iot263/listSimStatistics?iccId=' + params,
    method: 'get'
  })
}

export function apnPage(data) {
  return request({
    url: '/v3/manager/apn/page',
    method: 'post',
    data
  })
}
export function apnAdd(data) {
  return request({
    url: '/v3/manager/apn/add',
    method: 'post',
    data
  })
}
export function apnUpdate(data) {
  return request({
    url: '/v3/manager/apn/update',
    method: 'post',
    data
  })
}
export function apnDelete(data) {
  return request({
    url: '/v3/manager/apn/delete',
    method: 'post',
    data
  })
}
export function apnList() {
  return request({
    url: '/v3/manager/apn/list',
    method: 'post',
    data: {}
  })
}